//  @jsx h

import { bem } from '@nrk/dh-utils';
import { h } from 'preact';
var style = {
  'toggleMuteButton': 'dhfc-1_0_0-beta_28-toggleMuteButton',
  'toggleMuteButton__volumeIcon': 'dhfc-1_0_0-beta_28-toggleMuteButton__volumeIcon',
  'toggleMuteButton--muted': 'dhfc-1_0_0-beta_28-toggleMuteButton--muted',
  'toggleMuteButton__mutedIcon': 'dhfc-1_0_0-beta_28-toggleMuteButton__mutedIcon'
};


export default function ToggleMuteButton(props) {
  var muted = props.muted;

  var className = '' + bem(style.toggleMuteButton, muted && 'muted') + (props.className ? ' ' + props.className : '');

  return h(
    'button',
    { className: className, onClick: props.onClick },
    h(
      'span',
      { className: 'nrk-sr' },
      muted ? 'Slå på lyd' : 'Slå av lyd'
    ),
    h('svg', {
      className: style.toggleMuteButton__mutedIcon,
      'aria-hidden': 'true',
      dangerouslySetInnerHTML: {
        __html: '<use xlink:href="#nrk-media-volume--muted" />'
      }
    }),
    h('svg', {
      className: style.toggleMuteButton__volumeIcon,
      'aria-hidden': 'true',
      dangerouslySetInnerHTML: {
        __html: '<use xlink:href="#nrk-media-volume--3" />'
      }
    })
  );
}